module.exports = __webpack_public_path__ + "img/enterprise-top-pc.e70bdf79.jpg";